import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';
import ThumbsDown from '../../../../assets/images/ThumbsDown.svg';
import Fireworks from '../../../../assets/images/Fireworks.svg';

export const AnswerResultContainer = styled.div`
  text-align: center;
  animation: fade-in 0.6s ease-in-out;

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h3 {
    margin-bottom: ${spacing.space16};
  }

  p {
    margin: 0;
  }
`;

export const FireworksImage = styled(Fireworks)`
  margin-top: ${spacing.space16};
`;

export const ThumbsDownImage = styled(ThumbsDown)`
  margin-top: ${spacing.space16};
`;

export const FooterText = styled.div`
  margin-top: ${spacing.space24};
  margin-bottom: ${spacing.space16};
  display: flex;
  justify-content: flex-start;

  h3 {
    margin: 0;
    font-weight: 400;
    color: ${nafColor.signature.black};
  }
`;

export const StyledButtonLink = styled.div`
  margin-top: ${spacing.space16};
  display: flex;
  justify-content: flex-start;

  button {
    margin-left: 0;
    color: ${colors.secondary[500]};

    > span {
      border-bottom: 1px solid ${colors.secondary[500]};
      padding-bottom: 0;
    }

    &:hover {
      color: ${colors.secondary[500]};

      > span {
        border-bottom-color: ${colors.secondary[500]};
      }
    }
  }
`;
